import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { OOVenue } from 'src/app/shared/models/oo-venue';

@Component({
	selector: 'app-venue-locator',
	templateUrl: './venue-locator.component.html',
	styleUrls: ['../public.style.scss'],
})
export class VenueLocatorComponent implements OnInit {
	ooVenueList: OOVenue[];

	constructor(public app: AppService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		this.getVenues();
	}

	async getVenues() {
		const resp = await this.focuslink.venueGetAll(undefined, false);
		const tempList: OOVenue[] = resp.map((i) => new OOVenue(i));
		console.log(tempList);
		tempList.sort((a, b) => a.state.localeCompare(b.state));
		this.ooVenueList = tempList;
		console.log(tempList);
	}
}
